import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/SkillCoursesPopupLink';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const SkillCoursesSearcher = props => {
  const [skillCourseIds, setSkillCourseIds] = useState(props.skill_course_ids);
  const [shouldSubmit, setShouldSubmit] = useState(false);

  useEffect(() => {
    if (shouldSubmit) {
      $('form').submit();
    }
  },[shouldSubmit]);

  const url = (() => {
    const path = '/popup/member_skill_courses';
    const data = {
      selected_ids: skillCourseIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedSkillCourses => {
    setSkillCourseIds(selectedSkillCourses.map(skillCourse => skillCourse.id).join(','));
  };

  const onSubmit = () => {
    setShouldSubmit(true);
  };

  const onChangeSkillCoursesIds = event => {
    setSkillCourseIds(event.target.value);
  };

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.skillCourses}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={false}
        rootNode={document.querySelector('#popup_skill')}
        onClosePopup={onClosePopup}
        onSubmit={onSubmit}
        selectedNames={props.input_skill_course_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}

      />
      <input type="hidden"
             name="q[skill_ids]"
             onChange={onChangeSkillCoursesIds}
             value={skillCourseIds}
      />
    </>
  );
};

SkillCoursesSearcher.propTypes = {
  skill_course_ids: PropTypes.string,  // ie. "1,2,3"
  input_skill_course_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return (
    <>
      <a className="back select-skill-course-btn" onClick={props.onClickCloseButton}>他の条件を選択</a>
      <a className="search search-skill-course-btn" onClick={props.onClickSubmitButton}>この条件で検索</a>
    </>
  );
};

export default SkillCoursesSearcher;
